import { Link } from "react-router-dom";
import { Typography } from "@mui/material";
import color from "context/MaterialUITheme/color";

const CLogo: React.FC = () => {
  return (
    <Link
      to="/"
      style={{
        textDecoration: "none",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <Typography
        noWrap
        variant="h4"
        color="white"
        component="div"
        sx={{
          color: color.black,
          fontFamily: "Pro Display Bold",
        }}
      >
        <span style={{ color: color.purple }}>NFTY</span>Door.
      </Typography>
      <Typography
        noWrap
        variant="h6"
        color="white"
        component="div"
        marginTop={-1}
        fontSize={"1.3rem"}
        sx={{
          color: color.black,
          fontFamily: "Pro Display Regular",
        }}
      >
        <span>Home Equity Loans</span>
      </Typography>
    </Link>
  );
};

export default CLogo;
